import moment from 'moment'
import axios from 'axios'

const validPhone = (phone) => {
  let regex = /[^0-9()\s+-]/g
  let matches = phone.match(regex)

  return !matches
}

const classSort = (before, after, type = 'asc') => {
  let beforeName = String(before.name) || ''
  let afterName = String(after.name) || ''
  let beforeLevel = beforeName[0]
  let beforeClass = parseInt(toASCII(beforeName.substring(1)))
  let afterLevel = afterName[0]
  let afterClass = parseInt(toASCII(afterName.substring(1)))

  if (beforeLevel === '中' && afterLevel === '小') {
    return type === 'asc' ? 1 : -1
  }

  if (beforeLevel === '小' && afterLevel === '中') {
    return type === 'asc' ? -1 : 1
  }

  if (beforeClass < afterClass) {
    return type === 'asc' ? -1 : 1
  }

  if (beforeClass > afterClass) {
    return type === 'asc' ? 1 : -1
  }

  return 0
}

const basicSort = (before, after, field, type = 'asc', subField = null) => {
  let beforeVal, afterVal

  if (!subField) {
    beforeVal = before[field] || null
    afterVal = after[field] || null
  } else {
    beforeVal = before[field][subField] || null
    afterVal = after[field][subField] || null
  }

  if (beforeVal < afterVal) {
    return type === 'asc' ? -1 : 1
  }

  if (beforeVal > afterVal) {
    return type === 'asc' ? 1 : -1
  }

  return 0
}

const stringSortByInt = (before, after, field, type = 'asc', subField = null) => {
  let beforeVal, afterVal

  if (!subField) {
    beforeVal = parseInt(before[field])
    beforeVal = isNaN(beforeVal) ? 0 : beforeVal
    afterVal = parseInt(after[field])
    afterVal = isNaN(afterVal) ? 0 : afterVal
  } else {
    beforeVal = parseInt(before[field][subField])
    beforeVal = isNaN(beforeVal) ? 0 : beforeVal
    afterVal = parseInt(after[field][subField])
    afterVal = isNaN(afterVal) ? 0 : afterVal
  }

  if (beforeVal < afterVal) {
    return type === 'asc' ? -1 : 1
  }

  if (beforeVal > afterVal) {
    return type === 'asc' ? 1 : -1
  }

  return 0
}

const toASCII = (chars) => {
  let ascii = ''

  for(let i = 0, l = chars.length; i < l; i++) {
    let c = chars[i].charCodeAt(0)

    // make sure we only convert half-full width char
    if (c >= 0xFF00 && c <= 0xFFEF) {
      c = 0xFF & (c + 0x20)
    }

    ascii += String.fromCharCode(c)
  }

  return ascii
}

const timeSort = (before, after) => {
  before = before.split(':').map((val) => {
    return parseInt(val)
  })
  after = after.split(':').map((val) => {
    return parseInt(val)
  })

  if (before.length !== 2) {
    return 1
  }

  if (after.length !== 2) {
    return -1
  }

  if (before[0] < after[0]) {
    return -1
  }

  if (before[0] > after[0]) {
    return 1
  }

  if (before[1] < after[1]) {
    return -1
  }

  if (before[1] > after[1]) {
    return 1
  }

  return 0
}

const clearErrorMessages = (errorMessages) => {
  if (typeof errorMessages === 'object') {
    for (let key in errorMessages) {
      errorMessages[key] = []
    }
  }
}

const validEmail = (email) => {
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

const getQueryString = (filter, sort, page = null) => {
  let query = []

  if (filter !== null) {
    for (let field in filter) {
      if (filter[field] !== null) {
        query.push(`filter[${field}]=${filter[field]}`)
      }
    }
  }

  if (sort !== null) {
    for (let field in sort) {
      if (sort[field] !== null) {
        query.push(`sort[${field}]=${sort[field]}`)
      }
    }
  }

  if (page !== null) {
    page = parseInt(page)
    page = page ? page : 1
    query.push(`page=${page}`)
  }

  return query.join('&')
}

const getQueryStringPhase2 = (filter, sort, page = null, search = null, lang=null) => {
  let query = []

  if (filter !== null) {
    for (let field in filter) {
      if (filter[field] !== null) {
        query.push(`filters[${field}]=${filter[field]}`)
      }
    }
  }
  if (search !== null) {
    query.push(`search=${search}`)
  }

  if (sort !== null) {
    for (let field in sort) {
      if (sort[field] !== null) {
        query.push(`sorts[${field}]=${sort[field]}`)
      }
    }
  }

  if (page !== null) {
    page = parseInt(page)
    page = page ? page : 1
    query.push(`page=${page}`)
  }
  if (lang !== null) {
    query.push(`lang=${lang}`)
  }

  return query.join('&')
}

const downloadFileFromBlob = (data, type, name, extension) => {
  let typedArrayToURL = (typedArray, mimeType) => {
    return URL.createObjectURL(new Blob([data], {type: mimeType}))
  }

  let bytes = new Uint8Array(59);

  for (let i = 0; i < 59; i++) {
    bytes[i] = 32+i;
  }

  let url = typedArrayToURL(bytes, type)
  let link = document.createElement('a')
  link.href = url
  link.download = `${name}.${extension}`
  document.body.appendChild(link)
  link.click()
  link.remove()
}

const forceDownloadFile = (url, filename) => {
  axios({
    method: 'get',
    url: url,
    responseType: 'arraybuffer'
  })
  .then(response => {
    const href = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
  })
  .catch(() => {

  })
}
const formatDateTime = (format = 'YYYY-MM-DD HH:mm:ss', dateTime = null) => {
  let momentTime = dateTime ? moment(dateTime) : moment()
  return momentTime.format(format)
}
const checkTypeFile = (fileName) => {
  let stringTrim = fileName.split('.')
  let typeFile =  stringTrim.length > 0 ? stringTrim[stringTrim.length-1] : 'no'
  let arrImageType = ['jpg', 'jpeg', 'png', 'tiff', 'raw', 'svg', 'bmp', 'heic']
  let arrVideoType = ['mp3', 'mp4', 'mov', 'avi', 'flv', 'wmv', 'mpeg', 'divx', '3gp', 'm4a']
  let arrOfficeType = ['xlsx', 'doc', 'docx', 'dot', 'dotx', 'pot', 'potx', 'ppt', 'pptm', 'pptx', 'xlm', 'xls', 'xlsm', 'xltm', 'csv']
  let arrPDFType = ['pdf']
  let arrTxt ='txt'
  let checkType = 0
  if (arrVideoType.includes(typeFile.toLowerCase())) {
    checkType = 'video'
  } else if (arrImageType.includes(typeFile.toLowerCase())) {
    checkType = 'image'
  } else if (arrOfficeType.includes(typeFile.toLowerCase())) {
    checkType = 'office'
  } else if (arrPDFType.includes(typeFile.toLowerCase())) {
    checkType = 'pdf'
  }else if(arrTxt.includes(typeFile.toLowerCase())) {
    checkType='txt'
  } else {
    checkType = 'other'
  }
  return checkType
}

export {
  validPhone,
  classSort,
  basicSort,
  toASCII,
  timeSort,
  clearErrorMessages,
  validEmail,
  getQueryString,
  downloadFileFromBlob,
  forceDownloadFile,
  stringSortByInt,
  getQueryStringPhase2,
  formatDateTime,
  checkTypeFile
}
